import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PaperclipNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M18 7C17.4477 7 17 7.44772 17 8V16.5C17 19 14.709 20.5 12.5 20.5C10.291 20.5 8 19 8 16.5V6.5C8 4.5 9.5 4 11 4C12.5 4 13.5 5 13.5 6.5V15.5C13.5 16.052 13.052 16.5 12.5 16.5C11.948 16.5 11.5 16.052 11.5 15.5V8C11.5 7.44772 11.0523 7 10.5 7C9.94772 7 9.5 7.44772 9.5 8V15.5C9.5 17 10.5 18.5 12.5 18.5C14.5 18.5 15.5 17 15.5 15.5V6.5C15.5 4.5 14 2 11 2C8 2 6 4 6 6.5V16.5C6 20 9 22.5 12.5 22.5C16 22.5 19 20 19 16.5V8C19 7.44772 18.5523 7 18 7Z'
            fill='currentColor'
        />
    </svg>
));
